import { useState } from 'react';
import type { CuratedShop } from '@/mocks/curatedShops';

interface DesktopCTAProps {
  shop: CuratedShop;
}

export default function DesktopCTA({ shop }: DesktopCTAProps) {
  const [liked, setLiked] = useState(false);

  return (
    <div className="sticky top-6">
      <div className="bg-white rounded-2xl border border-cream-dark p-5 shadow-sm">
        <h3 className="font-serif text-xl text-navy mb-1">{shop.name}</h3>
        <p className="text-sm text-navy-light mb-4 leading-relaxed">
          {shop.subtitle}
        </p>

        <div className="space-y-2.5">
          <button className="w-full bg-navy text-white font-semibold rounded-xl py-3 text-sm transition-colors hover:bg-navy-light cursor-pointer whitespace-nowrap">
            상담 문의하기
          </button>
          {/* <button className="w-full bg-cream text-navy font-medium rounded-xl py-3 text-sm border border-cream-dark transition-colors hover:bg-cream-dark cursor-pointer whitespace-nowrap">
            예약하기
          </button> */}
        </div>

        <div className="mt-4 pt-3 border-t border-cream-dark flex items-center justify-between">
          <div className="flex items-center gap-1.5 text-xs text-navy-light">
            <i className="ri-chat-3-line text-softgold" />
            <span>
              실제 후기{' '}
              <span className="font-semibold text-navy">{shop.reviews}</span>개
            </span>
          </div>
          <button
            onClick={() => setLiked(!liked)}
            className="w-8 h-8 flex items-center justify-center rounded-full border border-cream-dark transition-colors cursor-pointer hover:bg-cream"
            aria-label={liked ? '찜 해제' : '찜하기'}
          >
            <i
              className={`${liked ? 'ri-heart-fill text-rose-400' : 'ri-heart-line text-navy'} text-base`}
            />
          </button>
        </div>

        <div className="mt-3 flex flex-wrap gap-1.5">
          {shop.tags.slice(0, 5).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 bg-cream rounded-full text-[11px] text-navy-light font-medium"
            >
              #{tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}